import { useQuery } from '@tanstack/react-query'
import { getMySecurityLedger } from '@/api/services/security-ledger.service'
import type { MySecurityLedgerListQuery } from '@/features/security-ledger/types/security-ledger.types'

const myLedgerKeys = {
  list: (params?: MySecurityLedgerListQuery) =>
    ['security-ledger-me', params] as const,
}

export function useMySecurityLedger(params?: MySecurityLedgerListQuery) {
  return useQuery({
    queryKey: myLedgerKeys.list(params),
    queryFn: () => getMySecurityLedger(params),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  })
}
